import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.createPOCustomField.presenters.createPOCustomFieldFormPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Custom field has been created.',
  },
  maxFieldsError: {
    id: `${scope}.maxFieldsError`,
    defaultMessage: 'There is a maximum of 12 purchase order custom fields.',
  },
  duplicateNameError: {
    id: `${scope}.duplicateNameError`,
    defaultMessage: 'Purchase order custom field names must be unique.',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to create the custom field.',
  },
})
